import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import { ApplicantContent, IProps } from './types';
// import moment from 'moment';
import moment from 'moment-timezone';
import _ from 'lodash';
import { NationalType } from 'constants/enums/nationalType.enum';
import commonService from 'utils/commonService';
import { InsType } from 'constants/enums/insType.enum';

const PolicyholderInfo: React.FC<IProps> = (props) => {
  const [mobileProtected, setMobileProtected] = useState<boolean[]>([...Array(props.APPLICANTS?.length)].map(() => true));
  const [addressProtected, setAddressProtected] = useState<boolean[]>([...Array(props.APPLICANTS?.length)].map(() => true));
  const [idProtected, setIdProtected] = useState<boolean[]>([...Array(props.APPLICANTS?.length)].map(() => true));
  const resources = useSelector((state: RootReducersState) => state.resources);

  /**
   * @description 處理手機資料顯示或隱藏切換
   */
  const handleMobileViewToggle = (targetIndex: number) => {
    const mobileProtectedUpdated = [...mobileProtected];
    mobileProtectedUpdated[targetIndex] = !mobileProtected[targetIndex];
    setMobileProtected(mobileProtectedUpdated);
  };

  /**
   * @description 處理地址資料顯示或隱藏切換
   */
  const handleAddressViewToggle = (targetIndex: number) => {
    const addressProtectedUpdated = [...addressProtected];
    addressProtectedUpdated[targetIndex] = !addressProtected[targetIndex];
    setAddressProtected(addressProtectedUpdated);
  };

  /**
   * @description 處理身份證字號(新式統一證號)資料顯示或隱藏切換
   */
  const handleIdViewToggle = (targetIndex: number) => {
    const idProtectedUpdated = [...idProtected];
    idProtectedUpdated[targetIndex] = !idProtected[targetIndex];
    setIdProtected(idProtectedUpdated);
  };

  /**
   * 建立多筆的要保人資訊
   */
  const handleCreateMultiInfo = (datas: ApplicantContent[]) => {
    return _.map(datas, (data: ApplicantContent, index: number) => {
      return (
        <div className="element__list" key={index}>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Document_type')}</div>
              <div className="element__list-group-content">{commonService.formatNullToDash(data.NATIVE)}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Name')}</div>
              <div className="element__list-group-content">{commonService.formatNullToDash(data.NAME)}</div>
            </div>
          </div>
          {
            data.APPLICANT_ID_TYPE !== NationalType.Legal && (
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Birth_date')}</div>
                  <div className="element__list-group-content">{data.BIRTHDAY ? moment(data.BIRTHDAY).format('YYYY/MM/DD') : '-'}</div>
                </div>
              </div>
            )
          }
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Phone_number')}</div>
              <div className="element__list-group-content">
                {!mobileProtected[index]
                  ? commonService.formatMobileNumAddDash(data.MOBILE)
                  : commonService.hiddenStringCharactersByIndexRange(commonService.formatMobileNumAddDash(data.MOBILE), 5, 8)}
                {data.MOBILE && (
                  <button type="button" className="element__view-btn" onClick={() => handleMobileViewToggle(index)}>
                    {!mobileProtected[index] ? <i className="fas fa-eye" /> : <i className="fas fa-eye-slash" />}
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Address')}</div>
              <div className="element__list-group-content">
                {!addressProtected[index]
                  ? commonService.formatNullToDash(data.ADDRESS)
                  : data.ADDRESS ? commonService.hiddenStringCharactersByIndexRange(commonService.formatNullToDash(data.ADDRESS), 13, 19) : commonService.formatNullToDash(data.ADDRESS)}
                {data.ADDRESS && data.ADDRESS.length > 13 && (
                  <button type="button" className="element__view-btn" onClick={() => handleAddressViewToggle(index)}>
                    {!addressProtected[index] ? <i className="fas fa-eye" /> : <i className="fas fa-eye-slash" />}
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_ID_New_UI_number')}</div>
              <div className="element__list-group-content">
                {!idProtected[index]
                  ? commonService.formatNullToDash(data.ID)
                  : commonService.hiddenStringLastCharacter(commonService.formatNullToDash(data.ID), 5)}
                {data.ID && (
                  <button type="button" className="element__view-btn" onClick={() => handleIdViewToggle(index)}>
                    {!idProtected[index] ? <i className="fas fa-eye" /> : <i className="fas fa-eye-slash" />}
                  </button>
                )}
              </div>
            </div>
          </div>
          {
            data.APPLICANT_ID_TYPE !== NationalType.Legal && (
              <>
                <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Gender')}</div>
                    <div className="element__list-group-content">{commonService.formatNullToDash(data.GENDER)}</div>
                  </div>
                </div>
                <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Marital_status')}</div>
                    <div className="element__list-group-content">{commonService.formatNullToDash(data.MARRIAGE_TEXT)}</div>
                  </div>
                </div>
              </>
            )
          }
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_EMail_address')}</div>
              <div className="element__list-group-content">{commonService.formatNullToDash(data.EMAIL)}</div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="policyholder-info">
      <div className="policyholder-info__title">{commonService.getNameByLng(resources, 'TID_Proposer_information')}</div>
      <div className="policyholder-info__content">
        {
          props.MULTI && props.APPLICANTS && props.APPLICANTS.length > 0 ? handleCreateMultiInfo(props.APPLICANTS) : (
            <div className="element__list">
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Document_type')}</div>
                  <div className="element__list-group-content">{commonService.formatNullToDash(props.NATIVE)}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Name')}</div>
                  <div className="element__list-group-content">{commonService.formatNullToDash(props.NAME)}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Birth_date')}</div>
                  <div className="element__list-group-content">{props.BIRTHDAY ? moment(props.BIRTHDAY).format('YYYY/MM/DD') : '-'}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Phone_number')}</div>
                  <div className="element__list-group-content">
                    {!mobileProtected[0]
                      ? commonService.formatMobileNumAddDash(props.MOBILE)
                      : commonService.hiddenStringCharactersByIndexRange(commonService.formatMobileNumAddDash(props.MOBILE), 5, 8)}
                    {props.MOBILE && (
                      <button type="button" className="element__view-btn" onClick={() => handleMobileViewToggle(0)}>
                        {!mobileProtected[0] ? <i className="fas fa-eye" /> : <i className="fas fa-eye-slash" />}
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Address')}</div>
                  <div className="element__list-group-content">
                    {!addressProtected[0]
                      ? commonService.formatNullToDash(props.ADDRESS)
                      : props.ADDRESS ? commonService.hiddenStringCharactersByIndexRange(commonService.formatNullToDash(props.ADDRESS), 13, 19) : commonService.formatNullToDash(props.ADDRESS)}
                    {props.ADDRESS && props.ADDRESS.length > 13 && (
                      <button type="button" className="element__view-btn" onClick={() => handleAddressViewToggle(0)}>
                        {!addressProtected[0] ? <i className="fas fa-eye" /> : <i className="fas fa-eye-slash" />}
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_ID_New_UI_number')}</div>
                  <div className="element__list-group-content">
                    {!idProtected[0]
                      ? commonService.formatNullToDash(props.ID)
                      : commonService.hiddenStringLastCharacter(commonService.formatNullToDash(props.ID), 5)}
                    {props.ID && (
                      <button type="button" className="element__view-btn" onClick={() => handleIdViewToggle(0)}>
                        {!idProtected[0] ? <i className="fas fa-eye" /> : <i className="fas fa-eye-slash" />}
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Gender')}</div>
                  <div className="element__list-group-content">{commonService.formatNullToDash(props.GENDER)}</div>
                </div>
              </div>
              {props.InsTypeId !== InsType.MobileDevice && props.InsTypeId !== InsType.Pet && (
                <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Marital_status')}</div>
                    <div className="element__list-group-content">
                      {commonService.formatNullToDash(props.MARRIAGE_TEXT)}
                    </div>
                  </div>
                </div>
              )}

              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_EMail_address')}</div>
                  <div className="element__list-group-content">{commonService.formatNullToDash(props.EMAIL)}</div>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default PolicyholderInfo;
